import React, { useState, useEffect } from 'react';
import styles from './SupportTicketModal.module.css';
// ✅ WORKING PATTERN:
const API_BASE_URL = "https://final-project-5ar7.onrender.com";
 // ✅ centralized API

const SupportTicketModal = ({ isOpen, onClose }) => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);

  useEffect(() => {
    if (isOpen) {
      fetchTickets();
    }
  }, [isOpen]);

  const fetchTickets = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/support/tickets`);
      if (response.ok) {
        const data = await response.json();
        setTickets(data.tickets || []);
      }
    } catch (error) {
      console.error('❌ Error fetching tickets:', error);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (ticketId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/support/tickets/${ticketId}/read`, {
        method: 'PATCH'
      });
      if (response.ok) {
        fetchTickets(); // Refresh the list
      }
    } catch (error) {
      console.error('❌ Error marking ticket as read:', error);
    }
  };

  const closeTicket = async (ticketId, adminNotes) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/support/tickets/${ticketId}/close`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ adminNotes })
      });
      if (response.ok) {
        fetchTickets(); // Refresh the list
        setSelectedTicket(null);
      }
    } catch (error) {
      console.error('❌ Error closing ticket:', error);
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'urgent': return '#dc2626';
      case 'high': return '#ea580c';
      case 'medium': return '#ca8a04';
      case 'low': return '#16a34a';
      default: return '#6b7280';
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority) {
      case 'urgent': return 'URGENT';
      case 'high': return 'HIGH';
      case 'medium': return 'MEDIUM';
      case 'low': return 'LOW';
      default: return 'NORMAL';
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>
            Support Tickets (
              {tickets.filter(t => t.status === 'open' && t.isNew).length} new
            )
          </h2>
          <button className={styles.closeButton} onClick={onClose}>×</button>
        </div>

        <div className={styles.modalContent}>
          {loading ? (
            <div className={styles.loading}>Loading tickets...</div>
          ) : tickets.length === 0 ? (
            <div className={styles.emptyState}>
              <div className={styles.emptyIcon}>📋</div>
              <p>No support tickets found</p>
            </div>
          ) : (
            <div className={styles.ticketsList}>
              {tickets.map(ticket => (
                <div
                  key={ticket.id}
                  className={`${styles.ticketItem} ${ticket.isNew ? styles.newTicket : ''}`}
                >
                  <div className={styles.ticketHeader}>
                    <div className={styles.ticketMeta}>
                      <span
                        className={styles.priorityBadge}
                        style={{ backgroundColor: getPriorityColor(ticket.priority) }}
                      >
                        {getPriorityLabel(ticket.priority)}
                      </span>
                      <span className={styles.ticketDate}>
                        {new Date(ticket.createdAt).toLocaleString()}
                      </span>
                    </div>
                    <div className={styles.ticketActions}>
                      {ticket.isNew && (
                        <button
                          className={styles.markReadBtn}
                          onClick={() => markAsRead(ticket.id)}
                        >
                          Mark Read
                        </button>
                      )}
                    </div>
                  </div>

                  <div className={styles.ticketContent}>
                    <h4 className={styles.ticketSubject}>{ticket.subject}</h4>
                    <div className={styles.ticketInfo}>
                      <span><strong>From:</strong> {ticket.name} ({ticket.email})</span>
                      <span><strong>Source:</strong> {ticket.source}</span>
                    </div>
                    <p className={styles.ticketMessage}>{ticket.message}</p>
                  </div>

                  <div className={styles.ticketFooter}>
                    <span className={`${styles.statusBadge} ${styles[ticket.status]}`}>
                      {ticket.status.toUpperCase()}
                    </span>
                    {ticket.status !== 'closed' && (
                      <button
                        className={styles.closeTicketBtn}
                        onClick={() => {
                          const notes = prompt('Add admin notes (optional):');
                          if (notes !== null) {
                            closeTicket(ticket.id, notes);
                          }
                        }}
                      >
                        Close Ticket
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupportTicketModal;
